import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const SubaccountActionsToggle = ({ subaccount, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(subaccount.active ? 'actions.deactivate' : 'actions.activate')}
    color={subaccount.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={subaccount.isLoading}
    onClick={(e) => {
      e.preventDefault();
      handleClick(subaccount.id);
    }}
  />
);

export default translate()(SubaccountActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/list/actions/SubaccountsActionsToggle.js